<ion-content class="ion-padding">{{comment()}}</ion-content>